import { render, staticRenderFns } from "./jhi-footer.vue?vue&type=template&id=6f18d6bb&"
import script from "./jhi-footer.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-footer.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports